import { ProposalEntity, User } from 'v2/models';
import { PROPOSAL_AFIRMATIVE } from '../../components/proposal_types';
import { PROVIDER_PROPOSAL_RESPONSE_KEY } from 'utils/constants';

export function isWaitingForSellerProposal(proposal: ProposalEntity) {
  return !proposal.archived && !proposal.data_provider_response;
}

export function isWaitingBuyerProposal(proposal: ProposalEntity) {
  return (
    !proposal.archived &&
    proposal.data_provider_response &&
    proposal.data_provider_response.action === 'affirmative' &&
    !proposal.data_buyer_response
  );
}

export function isApprovedProposal(proposal: ProposalEntity) {
  return (
    !proposal.archived && proposal.data_buyer_response?.action === 'affirmative'
  );
}

export function isClosedApprovedProposal(proposal: ProposalEntity) {
  return (
    proposal.archived &&
    proposal.data_buyer_response?.action === 'affirmative' &&
    proposal.data_provider_response?.action === 'affirmative'
  );
}

export function isClosedRejectedProposal(proposal: ProposalEntity) {
  return (
    proposal.data_buyer_response?.action === 'negative' &&
    proposal.data_provider_response?.action === 'affirmative'
  );
}

export function isClosedDeclinedProposal(proposal: ProposalEntity) {
  return proposal.data_provider_response?.action === 'negative';
}

export function isClosedCancelledProposal(proposal: ProposalEntity) {
  if (!proposal.archived) {
    return false;
  }
  if (!proposal.data_provider_response) {
    return true;
  }
  return (
    proposal.data_provider_response?.action === 'affirmative' &&
    !proposal.data_buyer_response
  );
}

export function getProposalUrl(proposal: ProposalEntity) {
  if (isWaitingForSellerProposal(proposal)) {
    return '/data-requests/active/waiting-seller';
  } else if (isWaitingBuyerProposal(proposal)) {
    return '/data-requests/active/waiting-buyer';
  } else if (isApprovedProposal(proposal)) {
    return '/data-requests/active/approved';
  } else if (isClosedApprovedProposal(proposal)) {
    return '/data-requests/closed/approved';
  } else if (isClosedRejectedProposal(proposal)) {
    return '/data-requests/closed/rejected';
  } else if (isClosedDeclinedProposal(proposal)) {
    return '/data-requests/closed/declined';
  } else if (isClosedCancelledProposal(proposal)) {
    return '/data-requests/closed/cancelled';
  }
  return '/data-requests';
}

export function isProposalAssignedToMe(
  proposal: ProposalEntity,
  user: User
): boolean {
  return proposal.assigned_to?.username === user.username;
}

export function getKeyCount(
  proposalList: ProposalEntity[],
  checkFunction?: (arg: ProposalEntity) => boolean
) {
  const keyCountObject: { [key: number]: number } = {};
  proposalList.forEach((proposal) => {
    if (checkFunction ? checkFunction(proposal) : true) {
      if (keyCountObject[proposal.search as number])
        keyCountObject[proposal.search as number] += 1;
      else keyCountObject[proposal.search as number] = 1;
    }
  });
  return keyCountObject;
}

export function filterApprovedProposals(proposalList: ProposalEntity[]) {
  return proposalList.filter(
    (proposal: ProposalEntity) =>
      proposal.archived === false &&
      proposal.data_provider_response &&
      proposal.data_provider_response.action === PROPOSAL_AFIRMATIVE
  );
}

export function get_data_buyer_description(
  proposal: ProposalEntity,
  isLongDescription = false
) {
  const { data_buyer_master, data_buyer_child } = proposal;

  const description = data_buyer_master
    ? data_buyer_master[
        isLongDescription ? 'long_description' : 'short_description'
      ] || data_buyer_master.vague_description
    : data_buyer_child[
        isLongDescription ? 'long_description' : 'short_description'
      ] || data_buyer_child.vague_description;

  return description || '';
}

export function loadResponseProgress(proposalId: number, searchId: number) {
  const savedResponse = localStorage.getItem(
    getProposalResponseProgressKey(proposalId, searchId)
  );
  if (savedResponse) {
    return JSON.parse(savedResponse);
  }
  return null;
}

export function getProposalResponseProgressKey(
  proposalId: number,
  searchId: number
) {
  return `${PROVIDER_PROPOSAL_RESPONSE_KEY}-${proposalId}-${searchId}`;
}

export function getProposalResponseAcceptedKey(
  proposalId: number,
  searchId: number
) {
  return `respond_to_${proposalId}_${searchId}`;
}
